import { Outlet, useNavigate } from 'react-router';

import Button from '@rio-cloud/rio-uikit/Button';
import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import useScoreStore from '../services/scoreStore';
import useScoreExtractStore from '../services/scoreExtractStore';
import { FormattedMessage } from 'react-intl';
import EmptyTruckSelection from '../features/emptyTruckSelection/index';
import { useEffect } from 'react';
import { useSelectAssetsStore } from '../services/selectAssetsStore';
import { useSelectExtractAssetsStore } from '../services/selectExtractAssetsStore';
import { useSelectVehicleStore } from '../services/selectVehicleSlice';
import { DateFilter } from '../features/dateFilter';
import { useDateFilterStore } from '../services/dateFilterStore';
import RelationshipCards from '../features/relationshipCards/relationshipCards';
import MainStateCard from '../features/mainStateCard/MainStateCard';
import { RouteMap } from '../routes/routeList';
import useRelationshipStore from '../services/relationshipStore';
import BehaviorCards from '../features/behaviorCards/BehaviorCards';


export function DashboardLayout() {
    const { data: score, loading, postScore } = useScoreStore();
    const { data: extractScore, loading: extractDataLoading, postExtractScore } = useScoreExtractStore();
    const { data: relationshipScore, loading: relationshipLoading, postScore: relationshipPostScore } = useRelationshipStore();
    const { selectedAssets } = useSelectAssetsStore();
    const { selectedExtractAssets } = useSelectExtractAssetsStore();
    const { startDate, endDate } = useDateFilterStore();
    const { clearScoreData } = useScoreStore();
    const { clearExtractScoreData } = useScoreExtractStore();
    const { clearSelectedVehicle } = useSelectVehicleStore();
    const navigate = useNavigate();
    const behaviorRoute = `/${RouteMap.get('behavior')}`;

    useEffect(() => {
        clearScoreData();
        clearExtractScoreData();
        clearSelectedVehicle();
        navigate(behaviorRoute);
    }, [])

    useEffect(() => {
        if (selectedAssets.length > 0) {
            postScore({ assets_ids: selectedAssets, start_date: startDate, end_date: endDate });
        }
        clearExtractScoreData();
    }, [startDate, endDate])

    useEffect(() => {
        if (selectedAssets.length > 0) {
            postScore({ assets_ids: selectedAssets, start_date: startDate, end_date: endDate });
            relationshipPostScore({ assetIds: selectedAssets });
        }
        clearExtractScoreData();
        navigate(behaviorRoute);
    }, [selectedAssets])

    useEffect(() => {
        if (selectedExtractAssets.length > 0) {
            postExtractScore({ assets_ids: selectedExtractAssets, start_date: startDate, end_date: endDate });
            relationshipPostScore({ assetIds: selectedExtractAssets });
        }
    }, [selectedExtractAssets])

    if (loading) {
        return (
            <div style={{ marginTop: '45vh' }}>
                <Spinner isDoubleSized />
            </div>
        )
    }

    if (selectedAssets.length === 0) {
        return (
            <div className='intro'>
                <EmptyTruckSelection
                    title={<FormattedMessage id='intl-msg:dashboard.welcome.title' />}
                    description={<FormattedMessage id='intl-msg:dashboard.welcome.description' />}
                />
            </div>
        );
    }

    return (
        <div style={{ display: 'grid', gap: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
                <DateFilter />
                <Button style={{ marginLeft: 'auto' }} bsStyle={Button.INFO} iconName='rioglyph-info-sign' disabled>
                    Informações Sobre Níveis E Ranking
                </Button>
            </div>
            <div>
                <MainStateCard />
                <StatsWidgets>
                    <BehaviorCards scoreData={score} data={extractScore ? extractScore : score} loading={extractDataLoading ? extractDataLoading : loading} />
                    <RelationshipCards data={extractScore ? extractScore : score} loading={extractDataLoading ? extractDataLoading : loading} />
                </StatsWidgets>
            </div>
            <Outlet />
        </div>
    );
}